export interface DatasetEditProps {
    label: string;
    description: string;
    businessOwnerEmail: string;
    businessOwnerDelegationEmails: string[];
    tags: string[];
    enableCrawler?: boolean;
    enableReadTrail?: boolean;
    datasetStageOptions?: string;
}

export interface DatasetCreateFormData {
    label: string;
    description: string;
    environmentUri: string;
    organizationUri: string;
    SamlAdminGroupName: string;
    owner: string;
    businessOwnerEmail: string;
    businessOwnerDelegationEmails: string[];
    tags: string[];
    datasetStageOptions?: string;
    enableCrawler?: boolean;
    enableReadTrail?: boolean;
    bucketName?: string;
    topics?: string[];
}
export const defaultCreateValues = {
    label: '',
    description: '',
    environmentUri: '',
    organizationUri: '',
    SamlAdminGroupName: '',
    owner: '',
    businessOwnerEmail: '',
    businessOwnerDelegationEmails: [],
    tags: [],
    enableReadTrail: false,
};
export interface SelectProps {
    label: string;
    value: string;
    key?: string;
}

export interface RequestAccessFormData {
    datasetUri: string;
    datasetLabel: string;
}
